export const url = "https://api.fooddepot.am";
